module.exports = __webpack_public_path__ + "img/蒙版组 1@2x_副本.147d4d06.webp";